import React from "react";
import { INotificationContext } from "./NotificationProvider.types";
import { defaultNotificationContextState } from "./NotificationProvider.state";

export const NotificationContext = React.createContext<INotificationContext>(
  defaultNotificationContextState,
);

export const useNotifications = () => React.useContext(NotificationContext);
